module.exports = __webpack_public_path__ + "img/advisory.a38387dd.svg";